/* eslint-disable react/destructuring-assignment */
import GetShopRegions from "../symbols/getShopCities";

interface State {
  data: Array<string> | null;
  loading: boolean;
  error: any;
}
const initialState: State = {
  data: null,
  loading: false,
  error: false,
};

// eslint-disable-next-line default-param-last
function GetShopFiltersReducer(state: State = initialState, action: any) {
  switch (action.type) {
    case GetShopRegions.GET_SHOP_CITIES:
      return { ...state, loading: true, error: false };
    case GetShopRegions.GET_SHOP_CITIES_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case GetShopRegions.GET_SHOP_CITIES_FAILURE:
      return {
        ...state,
        data: null,
        loading: false,
        error: action.payload,
      };
    case GetShopRegions.CLEAR_SHOP_CITIES:
      return {
        data: null,
        loading: false,
        error: false,
      };
    default:
      return state;
  }
}
export default GetShopFiltersReducer;
